import { z } from 'zod';
import { CAL_EVENT_MAX_PRODUCTS } from '../../events/cal-event-max-products.js';
import { optionalUuidArray, requiredUuidString } from '../zod-helpers/index.js';
export const SET_CAL_EVENT_PRODUCTS_MAX_CATEGORIES = 200;
export const setCalEventProductsInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    productIds: optionalUuidArray('Invalid product.', {
        maxItems: CAL_EVENT_MAX_PRODUCTS,
        tooManyMessage: `An event can have at most ${CAL_EVENT_MAX_PRODUCTS} products.`,
    }),
    categoryIds: optionalUuidArray('Invalid category.', {
        maxItems: SET_CAL_EVENT_PRODUCTS_MAX_CATEGORIES,
        tooManyMessage: 'Too many categories.',
    }),
    categoryRowIds: optionalUuidArray('Invalid category.', {
        maxItems: SET_CAL_EVENT_PRODUCTS_MAX_CATEGORIES,
        tooManyMessage: 'Too many categories.',
    }).default([]),
    noProductsToReport: z.boolean().nullish(),
});
//# sourceMappingURL=set-cal-event-products-input.js.map